import React from 'react';
import type { AudioPlayerPayload } from '../../../data-access/api/science/openapi/api';
import './richContext.scss';

type Props = {
  p: AudioPlayerPayload;
};

const AudioPlayerContent: React.FC<Props> = ({ p }) => {
  return (
    <div className="rc-content-body">
      <span className="rc-content-label">{p.track_name}</span>
      <div className="rc-pill-row">
        {!!p.category && (
          <div className="rc-tag-pill">
            <span className="rc-tag-pill-text">{p.category}</span>
          </div>
        )}
        {typeof p.duration_min === 'number' && (
          <div className="rc-tag-pill">
            <span className="rc-tag-pill-text">{p.duration_min} min</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AudioPlayerContent;
